import { acceptedLanguages } from '@/lib/translation/acceptedLanguages'

export const getLanguage = (): string => {
  const language = navigator.language.split('-')[0]
  if (!acceptedLanguages.includes(language)) return acceptedLanguages[0]

  return language
}
